/* @pareto-engineering/generator-front 1.1.1-alpha.0 */
import * as React from 'react'
import { useLazyLoadQuery } from 'react-relay'
import { Route, Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'

const query = graphql`
  query TesterTimeQuery {
    time
  }
`

const componentClassName = 'tester'

const Time = () => {
  const payload = useLazyLoadQuery(query)

  return (
    <p>{ payload.time }</p>
  )
}

/**
 * This is the component description.
 */
const Tester = ({
  id,
  className:userClassName,
  style,
  children,
  // ...otherProps
}) => {
  <div
    id={id}
    className={[

      // baseClassName,

      componentClassName,
      userClassName,
    ]
      .filter((e) => e)
      .join(' ')}
    style={style}
  >
    <Link to="/page1">
      LINK 1
    </Link>
    <Link to="/page2">
      LINK 2
    </Link>

    <Route path="/page1">
      <Helmet>
        <title>The title of the page</title>
      </Helmet>
      <React.Suspense fallback="loading">
        <Time />
      </React.Suspense>
    </Route>
    <Route path="/page2">
      <Helmet>
        <title>P2</title>
      </Helmet>
      PAGE 2 DISPLAYS HERE
    </Route>
    {children}
  </div>
}

export default Tester
